export const table_styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing(),
        marginLeft: 'auto',
        marginRight: 'auto',
        marginBottom: theme.spacing(),
    },
    root1: {
        marginTop: theme.spacing(),
        marginLeft: 'auto',
        marginRight: 'auto',
        borderRadius: '5px',
    },
    rootLeads: {
        width: '98%',
        marginTop: theme.spacing(),
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    table: {
        minWidth: 500,
    },
    tableWrapper: {
        overflowX: 'auto',
    },
});



// WEBPACK FOOTER //
// ./src/components/TableStyles.js